<template>
<!-- Navigation -->
    <nav>
        <div class="container">
            <a href="#home" class="nav-logo">SJ</a>
            <div class="nav-icons">
                <a href="https://www.linkedin.com/in/sivajyothi/" target="_blank" rel="noopener noreferrer" class="icon-link" aria-label="LinkedIn Profile">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                        <rect x="2" y="9" width="4" height="12"></rect>
                        <circle cx="4" cy="4" r="2"></circle>
                    </svg>
                </a>
                <a href="mailto:sivajyothirmayi.p@gmail.com" class="icon-link" aria-label="Email">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'HeaderComponent'
}
</script>

<style scoped>
/* Navigation styles are already in the main CSS, but here are the icon-specific styles */
.nav-icons {
    display: flex;
    gap: 1.5rem;
    align-items: center;
}

.icon-link {
    color: var(--text-medium);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-link:hover {
    color: var(--accent-gold);
    transform: translateY(-2px);
}

.icon-link svg {
    width: 24px;
    height: 24px;
}
</style>